var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.themeModel || 'theme-dark'},[_c('v-app',[_c('router-view',{attrs:{"id":"routerView"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }